import {NgModule} from "@angular/core";
import { CommonModule } from '@angular/common';

import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ComboToolsComponent} from "./comboTools.component";
import { ButtonModule } from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';


@NgModule({
  declarations: [ComboToolsComponent],
  imports     : [ CommonModule, 
                  MatTooltipModule,
                  ButtonModule,
                  DropdownModule,
                  ReactiveFormsModule,
                  FormsModule,
                  BsDropdownModule.forRoot()
                ],
  exports     : [
    ComboToolsComponent,
                ],  
})

export class ComboToolsModule {}
